import { Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { RadioButton, RadioButtonGroup } from "@songtradr/component-library";
import { FormFieldWrapper } from "../../../form-field-wrapper/FormFieldWrapper";
import { Props, RadioGroupWrapper } from "./RadioField.Parts";

export const RadioField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>({
  control,
  errors,
  rules,
  label,
  name,
  single,
  disabled,
  fieldOptions,
}: Props<FormFields, FieldName>) => {
  return (
    <FormFieldWrapper
      $single={single}
      name={name}
      label={label || <>&nbsp;</>}
      error={errors[name] as FieldError}
    >
      <Controller
        name={name}
        control={control}
        rules={{ ...rules }}
        render={({ field: controllerField }) => (
          <RadioButtonGroup
            name={name}
            value={controllerField.value || ""}
            onValueChange={controllerField.onChange}
            disabled={disabled}
          >
            <RadioGroupWrapper>
              {fieldOptions.map((option) => (
                <RadioButton
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </RadioButton>
              ))}
            </RadioGroupWrapper>
          </RadioButtonGroup>
        )}
      />
    </FormFieldWrapper>
  );
};
